/**
 * Shared labels and formatting for the coach admin follow-up pages.
 * Every label goes through the __() translation mixin (EN keys, DE translations in resources/lang/de/app/follow-up.json).
 */
export default {
    methods: {
        stageLabel(stage) {
            return {
                contact_1: this.__('1st contact'),
                contact_2: this.__('2nd contact'),
                contact_3: this.__('3rd contact'),
                recontact: this.__('Contact again'),
                registration: this.__('Unfinished registration'),
                nurse_followup: this.__('1 week after handover to nurse')
            }[stage] || stage
        },
        typeLabel(type) {
            return {
                prescription: this.__('Rezept-Service form'),
                registration: this.__('Code registration')
            }[type] || type
        },
        // button labels are deliberately lowercase; "activated" reads "resolved" for code registrations
        actionLabel(action, type) {
            return {
                activated: type === 'registration' ? this.__('resolved') : this.__('activated'),
                reached_has_code: this.__('reached, has code'),
                reached_waiting: this.__('reached, waiting'),
                not_reached: this.__('not reached'),
                complicated: this.__('complicated'),
                snooze: this.__('remind in 2 days'),
                nurse_ok: this.__('ok'),
                sent_to_nurse: this.__('sent to nurse'),
                second_diagnosis: this.__('2nd diagnosis'),
                cancel: this.__('cancel case'),
                restore: this.__('restore')
            }[action] || action
        },
        actionDoneMessage(action, type) {
            return {
                activated: type === 'registration' ? this.__('Marked as resolved.') : this.__('Marked as activated.'),
                reached_has_code: this.__('Saved. Reminder "contact again" in 3 working days.'),
                reached_waiting: this.__('Saved. Reminder "contact again" in 5 working days.'),
                not_reached: this.__('Saved. The next contact attempt is scheduled.'),
                complicated: this.__('Moved to complicated cases.'),
                snooze: this.__('Reminder postponed by 2 days.'),
                nurse_ok: this.__('Reminder dismissed.'),
                sent_to_nurse: this.__('Marked as sent to nurse. Reminder in 7 days.'),
                second_diagnosis: this.__('2nd diagnosis started. 1st contact in 8 working days.'),
                cancel: this.__('Case cancelled.'),
                restore: this.__('Case restored to complicated cases.')
            }[action] || this.__('Saved.')
        },
        /** Button labels are lowercase; elsewhere (filters, history) they start with a capital. */
        capitalize(label) {
            return label.charAt(0).toUpperCase() + label.slice(1)
        },
        tagLabel(tag) {
            return {
                expertsconnect: 'ExpertsConnect',
                second_diagnosis: this.__('2nd diagnosis'),
                sent_to_nurse: this.__('Sent to nurse'),
                complicated: this.__('Complicated'),
                activated: this.__('Activated'),
                cancelled: this.__('Case cancelled')
            }[tag] || tag
        },
        eventLabel(action, type) {
            const label = {
                created: this.__('Case created'),
                auto_activated: type === 'registration'
                    ? this.__('Resolved automatically (registration finished)')
                    : this.__('Activated automatically (patient linked)'),
                note_updated: this.__('Note updated')
            }[action] || this.actionLabel(action, type)

            return this.capitalize(label)
        },
        actionVariant(action) {
            return {
                activated: 'primary',
                nurse_ok: 'primary',
                cancel: 'ghost'
            }[action] || 'secondary'
        },
        actionColor(action) {
            return {
                activated: 'green',
                complicated: 'danger',
                cancel: 'danger'
            }[action] || 'default'
        },
        // the last "note updated" entry of the history (events are newest first)
        noteUpdatedAt(caseData) {
            const event = (caseData.events || []).find((item) => item.action === 'note_updated')

            return event ? event.created_at : null
        },
        formatDate(value) {
            return value ? this.moment(value).format('D. M. YYYY') : ''
        },
        formatDateTime(value) {
            return value ? this.moment(value).format('D. M. YYYY HH:mm') : ''
        },
        fromNow(value) {
            return value ? this.moment(value).fromNow() : ''
        },
        overdueDays(dueAt) {
            return Math.max(0, this.moment().startOf('day').diff(this.moment(dueAt).startOf('day'), 'days'))
        },
        yesNo(value) {
            return value ? this.__('yes') : this.__('no')
        }
    }
}
